import { Add } from '@mui/icons-material';
import { Avatar, CardHeader, IconButton, TAGTypography } from '../../..';
import React from 'react';

var DefaultCardHeader = function DefaultCardHeader(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? undefined : _ref$theme,
      plusButtonBoolean = _ref.plusButtonBoolean,
      avatarBoolean = _ref.avatarBoolean,
      avatarAltText = _ref.avatarAltText,
      avatarImgPath = _ref.avatarImgPath,
      _ref$cardTextAlignmen = _ref.cardTextAlignment,
      cardTextAlignment = _ref$cardTextAlignmen === void 0 ? 'start' : _ref$cardTextAlignmen,
      cardTitle = _ref.cardTitle,
      cardBody = _ref.cardBody;
  return React.createElement(CardHeader, {
    sx: {
      flexGrow: 1,
      textAlign: cardTextAlignment
    },
    avatar: theme !== 'SmallImageOnTop' && theme !== 'BigImageOnTop' && avatarBoolean ? React.createElement(Avatar, {
      alt: avatarAltText,
      src: avatarImgPath
    }) : false,
    disableTypography: true,
    title: React.createElement(TAGTypography, {
      variant: "h3",
      color: "text.primary",
      sx: {
        marginBottom: '16px'
      }
    }, cardTitle),
    subheader: cardBody,
    action: theme !== 'SmallImageOnTop' && plusButtonBoolean ? React.createElement(IconButton, null, React.createElement(Add, {
      fontSize: "large"
    })) : false
  });
};

export default DefaultCardHeader;